/**
 * Timer parser and property formatter. Timer extends Node, so it has no
 * visual representation.
 */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseTimer } from './parser';
import { formatTimerProperties } from './propertyFormatter';
const timerRegistration = {
    typeName: 'Timer',
    parser: parseTimer,
    propertyFormatter: formatTimerProperties,
};
nodeRegistry.register(timerRegistration);
export * from './parser';
export * from './propertyFormatter';
export * from './types';
//# sourceMappingURL=index.js.map